import React from 'react';

const FormLink = ({ label, onClick, className }) => (
    <a 
        href="#" 
        onClick={e => {
            e.preventDefault(); 
            onClick();
        }}
        // className="" 
        
    >
       <u style={{fontSize:'12px',color: "rgb(87, 91, 97)" }}>{label}</u>
    </a>
);

export default FormLink;
